module.exports = __webpack_public_path__ + "static/img/2.2e576c72.png";